import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class MiscService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  getTreatmentList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-treatment-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  addTreatment(data)
  {
      var formData: any = new FormData();
      for (const key in data)
      {
        formData.append(key, data[key]);
      }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-treatment',formData,{headers:webheader})
  }

  getTreatmentData(data)
  {
      let treatment_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-treatment-data/'+treatment_id,{headers:webheader})
  }

  updateTreatment(data)
  {
    var formData: any = new FormData();
      for (const key in data)
      {
        formData.append(key, data[key]);
      }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-treatment-data',formData,{headers:webheader})
  }

  getIpdResourcesList(type,pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-IpdResources-list/'+type+'/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  addIpdResource(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-IpdResource',data,{headers:webheader})
  }

  getIpdResourceData(data)
  {
      let record_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-ipdResource-data/'+record_id,{headers:webheader})
  }

  updateIpdResource(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-ipdResource-data',data,{headers:webheader})
  }

  getTreat_Category()
  {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-Treat-Category',{headers:webheader})
  }

  getDentalTraetment()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-dental-treatment',{headers:webheader})
  }

  getAssignTreat_Category()
  {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-assign-Treat-Category',{headers:webheader})
  }

  getCityList()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-city-list',{headers:webheader})
  }

  getLocationList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-location-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  addLocation(data)
  {
      var formData: any = new FormData();
      for (const key in data)
      {
        formData.append(key, data[key]);
      }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-location',formData,{headers:webheader})
  }

  getLocationData(data)
  {
      let location_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-location-data/'+location_id,{headers:webheader})
  }

  updateLocation(data)
  {
    var formData: any = new FormData();
      for (const key in data)
      {
        formData.append(key, data[key]);
      }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-location-data',formData,{headers:webheader})
  }

  getCities(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-manage-cities/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }
// ----------Master Pin Code----------//

  getCircle_zone(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-circle-wisezone?'+data,{headers:webheader})
  }

  savePinCode(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-edit-pin-code',data,{headers:webheader})
  }

  getPinCodeList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-pin-code-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }
  getPinCodeEditData(data)
  {
      let pincode_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-update-pin-code-data/'+pincode_id,{headers:webheader})
  }
  uploadPincodecsv(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-pincode-csv',data,{headers:webheader})
  }

// ----------Master Zone----------//
addEditZone(data)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-edit-zone',data,{headers:webheader})
}
getZoneList(pageno,limit,qstring)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-zone-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
}

getZoneEditData(data)
  {
      let zone_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-update-zone-data/'+zone_id,{headers:webheader})
  }

  uploadZonecsv(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-zone-csv',data,{headers:webheader})
  }
// ----------Zone Machine Master----------//
  getallScanMachine()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-all-scan-machine',{headers:webheader})
  }
  saveZoneMachine(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-edit-zone-machine',data,{headers:webheader})
  }
  getZoneMachineList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-zone-machine-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }
  getZoneMachineEditData(data)
  {
      let zoneMachine_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-update-zone-machine-data/'+zoneMachine_id,{headers:webheader})
  }
   

    // ----------Scan Machine----------//
    addEditMachine(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-edit-machine',data,{headers:webheader})
    }
    getMachineList(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-machine-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }
    getMachineEditData(data)
    {
        let machine_id = data;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-update-machine-data/'+machine_id,{headers:webheader})
    }

    gettocReportData(qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-ctoc-report-data'+'?'+qstring, {headers:webheader}) 
    }

    getbdctocReportData()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-bd-ctoc-report-data', {headers:webheader}) 
    }

    getServices()
  {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-services',{headers:webheader})
  }

    gettocReportDataForFeedback(qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'reports/get-ctoc-report-data-for-feedback'+'?'+qstring, {headers:webheader}) 
    }
// ---------- Zone Scan Pro Master ----------//
  saveZoneScanPro(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-edit-zone-scan-pro-master',data,{headers:webheader})
  }
  getZoneScanProList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-zone-scan-pro-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }
  getZoneScanProEditData(data)
  {
      let scan_pro_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-update-zone-scan-pro-data/'+scan_pro_id,{headers:webheader})
  }

//-------------------user-status-wise-report--------------------------//
getUserStatusWiseReportData(qstring)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'reports/get-user-status-wise-report-data'+'?'+qstring, {headers:webheader}) 
}

//-------------------Bridge Number--------------------------//
getBridgeList(pageno,limit,qstring)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-bridge-number-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
}

getBridgeEditData(data)
{
    let bridge_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-update-bridge-data/'+bridge_id,{headers:webheader})
}

saveEditBridge(data)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'save-edit-bridge-data',data,{headers:webheader})
}
//-------------------Bd-wise-report--------------------------//
getBdWiseReportData(qstring)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'reports/get-bd-wise-report-data'+'?'+qstring, {headers:webheader}) 
}

//------------------------Kaleyra-Lead-Source-----------------------//
kaleyra_Lead_Source()
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-kaleyra-lead-source',{headers:webheader})
}

//------------------------Kaleyra-Lead-Source-----------------------//

addSpecialties(data)
{
    var formData: any = new FormData();
    for (const key in data)
    {
        formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-specialties-data',formData,{headers:webheader})
}

getSpecialtiesList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-specialties-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

updateSpecialties(data)
  {
    var formData: any = new FormData();
      for (const key in data)
      {
        formData.append(key, data[key]);
      }
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-specialties-data',formData,{headers:webheader})
  }

getSpecialtiesData(data)
  {
      let specialties_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-specialties-data/'+specialties_id,{headers:webheader})
  }
  
  getLocalitiesList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-localities-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }
  uploadlocalitiesCsv(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-localities-csv',data,{headers:webheader})
  }

//------------------------Plan Package List-----------------------//
  getPlanPackageList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-plan-package-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }
  savePlanPackage(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-edit-plan-package',data,{headers:webheader})
  }
  getPlanPackageEditData(data)
  {
      let plan_id = data;
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-update-plan-package-data/'+plan_id,{headers:webheader})
  }
//---------------------------Vendor List------------------------//
  getVendorList()
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-vendor-list-data',{headers:webheader})
  }
}
